import React, { useEffect } from "react";
import { Rating } from "@mui/material";

const FormRender = ({ data }) => {
  return (
    <>
      {data.map((field, index) => {
        switch (field.element) {
          case "Dropdown":
            return (
              <div key={index} className="mb-3">
                <label
                  className="form-label"
                  dangerouslySetInnerHTML={{ __html: field.question }}
                ></label>
                {field.options.length > 0 ? (
                  <select value={field.answer} readOnly className="form-select">
                    {field.options.map((option, optionIndex) => (
                      <option key={optionIndex} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                ) : (
                  <select value={field.answer} readOnly className="form-select">
                    <option selected>{field.answer}</option>
                  </select>
                )}
              </div>
            );

          case "Checkboxes":
            return (
              <div key={index} className="mb-3">
                <label
                  className="form-label"
                  dangerouslySetInnerHTML={{ __html: field.question }}
                ></label>
                {field.options.map((option, optionIndex) => (
                  <div key={optionIndex} className="form-check">
                    <input
                      type="checkbox"
                      checked={field.answer.includes(option)}
                      readOnly
                      className="form-check-input"
                    />
                    <span className="form-check-label">{option}</span>
                  </div>
                ))}
              </div>
            );
          case "Rating":
            return (
              <div key={index} className="mb-3">
                <label
                  className="form-label w-100"
                  dangerouslySetInnerHTML={{ __html: field.question }}
                ></label>
                <div className="w-100 d-flex justify-content-start">
                  <Rating
                    name="half-rating"
                    value={field.answer}
                    precision={0.5}
                    readOnly
                  />
                </div>
              </div>
            );

          case "TextInput":
            return (
              <div key={index} className="mb-3">
                <label
                  className="form-label"
                  dangerouslySetInnerHTML={{ __html: field.question }}
                ></label>
                <input
                  type="text"
                  value={field.answer}
                  readOnly
                  className="form-control"
                />
              </div>
            );
          case "NumberInput":
            return (
              <div key={index} className="mb-3">
                <label
                  className="form-label"
                  dangerouslySetInnerHTML={{ __html: field.question }}
                ></label>
                <input
                  type="number"
                  value={field.answer}
                  readOnly
                  className="form-control"
                />
              </div>
            );
          case "RadioButtons":
            return (
              <div key={index} className="mb-3">
                <label
                  className="form-label"
                  dangerouslySetInnerHTML={{ __html: field.question }}
                ></label>
                {field.options.map((option, optionIndex) => (
                  <div key={optionIndex} className="form-check">
                    <input
                      type="radio"
                      checked={field.answer.includes(option)}
                      readOnly
                      className="form-check-input"
                    />
                    <span className="form-check-label">{option}</span>
                  </div>
                ))}
              </div>
            );
          case "TextArea":
            return (
              <div key={index} className="mb-3">
                <label
                  className="form-label"
                  dangerouslySetInnerHTML={{ __html: field.question }}
                ></label>
                <textarea
                  value={field.answer}
                  readOnly
                  className="form-control"
                  rows={5}
                />
              </div>
            );

          default:
            return null;
        }
      })}
    </>
  );
};

export default FormRender;
